import type { DeepString } from "@/lib/i18n";

/**
 * CDescriptivePage — polskie tłumaczenia (puste / brak zawartości).
 *
 * Renderowanie akapitów delegowane do `<ParagraphRenderer>` — tłumaczenia
 * per-layout siedzą w `@/components/cms/Paragraphs/Paragraph.i18n`.
 */
export const pl = {
  emptyData: "Brak danych do wyświetlenia.",
  emptyContent: "Strona nie zawiera jeszcze treści.",
} as const;

export type CDescriptivePageTranslations = DeepString<typeof pl>;
